import styled from 'styled-components';

import { Format } from '../../../../utils/styles-constants';

interface ButtonProps {
	disabled: boolean;
}

const List = styled('ul')`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin: 0;
	padding: 10px 48px;
	list-style-type: none;

	@media ${Format.Smartphone}, ${Format.SmartphoneLandscape} {
		padding: 10px 32px;
	}
`;

const ListItem = styled('li')`
	position: relative;
	padding-right: 20px;

	&:only-child {
		button {
			font-size: 20px;
		}
	}

	svg {
		position: absolute;
		top: 0;
		right: 5px;
		height: 30px;
		width: 10px;
		fill: currentColor;
	}
`;

const Button = styled('button')`
	height: 30px;
	padding: 0;
	border: 0;
	outline: 0;
	background: transparent;
	font-family: HelveticaNeue, sans-serif;
	font-weight: ${(props: ButtonProps) => props.disabled ? '700' : '400'};
	font-size: 13px;
	line-height: 30px;
	color: currentColor;
	cursor: ${(props: ButtonProps) => props.disabled ? 'default' : 'pointer'};
`;

export {
	List,
	ListItem,
	Button
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceSelector/DrivePicker/Breadcrumbs/styles.ts